import * as React from "react";

import AreaChart from "./AreaChart";

export default function TimelineHappy() {
  const xLabels = ["happy"];
  const data = [
    {
      time: 1733897192,
      happy: 52,
      situation: "Just woke up, feeling tired.",
    },
    {
      time: 1733902232,
      happy: 71,
      situation: "Getting ready for work, partner left a nice note.",
    },
    {
      time: 1733905832,
      happy: 10,
      situation: "Missed my bus.",
    },
    {
      time: 1733909432,
      happy: 22,
      situation: "Still walking to work.",
    },
    {
      time: 1733913032,
      happy: 41,
      situation: "Arrived at work, just in time for meeting.",
    },
    {
      time: 1733919332,
      happy: 83,
      situation: "Working on a cool project, able to use m-Path.",
    },
    {
      time: 1733925632,
      happy: 92,
      situation: "Making progress, found cool feature in m-Path.",
    },
    {
      time: 1733932832,
      happy: 45,
      situation: "Stressful meeting.",
    },
    {
      time: 1733938232,
      happy: 68,
      situation: "Going home, didn't miss my bus this time.",
    },
    {
      time: 1733943632,
      happy: 75,
      situation: "Nice meal with partner.",
    },
  ];
  return (
    <AreaChart data={data} dataKeyXAxis={"time"} dataKeysYAxis={xLabels} />
  );
}
